import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/websiteBuilderRoot";
import { WebsiteBuilderActionType } from "../../websiteBuilderAction";
import { TWebsiteBuilderMainSection } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderSection";

export type TMoveSectionDirection = "up" | "down";

export interface IMoveSectionActionPayload {
  id: string;
  index: number;
  direction: TMoveSectionDirection;
}

export interface IMoveSectionAction {
  type: typeof WebsiteBuilderActionType.MOVE_SECTION;
  payload: IMoveSectionActionPayload;
}

export function getMoveSectionInverseAction(action: IMoveSectionAction): IMoveSectionAction {
  const { id, index, direction } = action.payload;

  return {
    type: WebsiteBuilderActionType.MOVE_SECTION,
    payload: {
      id,
      index: direction === "up" ? index - 1 : index + 1,
      direction: direction === "up" ? "down" : "up",
    },
  };
}

export function applyMoveSectionTreeChange(tree: IWebsiteBuilderRoot, action: IMoveSectionAction): IWebsiteBuilderRoot {
  const { id, index, direction } = action.payload;

  if (tree.header.id === id || tree.footer.id === id) {
    return tree;
  }

  let nextIndex: number | null = null;

  if (direction === "up") {
    nextIndex = index - 1;
  } else if (direction === "down") {
    nextIndex = index + 1;
  } else {
    return tree;
  }

  if (nextIndex < 0 || nextIndex > tree.children.length - 1) {
    return tree;
  }

  const updatedTreeChildren: TWebsiteBuilderMainSection[] = [];

  for (let i = 0; i < tree.children.length; i++) {
    if (i === nextIndex) {
      updatedTreeChildren.push(tree.children[index]);
    } else if (i === index) {
      updatedTreeChildren.push(tree.children[nextIndex]);
    } else {
      updatedTreeChildren.push(tree.children[i]);
    }
  }

  return {
    ...tree,
    children: updatedTreeChildren,
  };
}
